<div class="sg-report-query-host">
  <div class="sg-flex-row sg-justify-end sg-items-center">
    <div class="sg-flex-auto sg-corp-event-query-container">
      @if (showLoadingFill) {
        <div class="sg-report-query-host-initial">
          <div class="sg-report-query-form">
            @for (i of _countHint; track $index) {
              <div class="form-control"></div>
            }
          </div>
        </div>
      }
      <ng-content select="pbl-nform"></ng-content>
    </div>
    @if (!hideSearchButton) {
      <div class="sg-padding-right-15">
        <sg-button variant="primary" [text]="buttonLabel" [disabled]="busy$ | async" (onClick)="commit()"></sg-button>
      </div>
    }
  </div>
  @if (dynForm?.renderState | async) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</div>
<ng-template #queryItemTpl let-ctx>
  <div class="form-control filter-{{ ctx.item?.name }}">
    <div class="sg-clear-field-container">
      <material-form-control-renderer
        sgClearField
        [hideClearField]="ctx.item.vType === 'boolean' || ctx.item.vType === 'checkbox'"
        [controlSource]="ctx.fControl"
        [nFormCmp]="dynForm"
        [nForm]="ctx.nForm"
        [fArray]="ctx.fArray"
        [fControl]="ctx.fControl"
        [fGroup]="ctx.fGroup"
        [item]="ctx.item"></material-form-control-renderer>
    </div>
  </div>
</ng-template>
